<template>
    <div class="head-content">
        <div class="head-body">
            <img v-once src="./../assets/logo.png" class="logo-img" alt="">
            <template v-for="(item,index) in menuList">
                <router-link :to="item.ptah"
                             :key="index"
                             exact-active-class="menu-item-active"
                             class="menu-item">{{item.name}}</router-link>
                <div v-if="index<menuList.length-1" class="menu-line"></div>
            </template>

            <div v-if="userInfo.detail" class="login-content">
                <el-dropdown @command="handleCommand">
                    <div class="login-content">
                        <el-avatar size="small" :src="`/api/v1/file/${userInfo.detail.portrait}`"></el-avatar>
                        <div class="cur-p" style="margin: 0 4px;">{{userInfo.detail.nickname}}</div>
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                                v-for="(item,index) in dropdownList"
                                :key="index"
                                :icon="item.icon"
                                :command="item.command">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div v-else class="login-content">
                <div class="menu-item" @click="showLogin=true">登录</div>
                <div class="menu-line"></div>
                <div class="menu-item" @click="showRes=true">注册</div>
            </div>
        </div>
        <LoginDialog v-model="showLogin" @openRes="showRes=true"></LoginDialog>
        <RegisterDialog v-model="showRes" @openLogin="showLogin=true" :identifierList="identifiers"></RegisterDialog>
    </div>
</template>

<script>
    import LoginDialog from "@/components/LoginDialog";
    import RegisterDialog from "@/components/RegisterDialog";
    import {mapState} from 'vuex'
    import {delToast} from '@/utlis/decorators'

    export default {
        name: "Header",
        components: {LoginDialog, RegisterDialog},
        data() {
            return {
                showLogin: false,
                showRes: false,
                menuList: [
                    {name: '网站首页', ptah: '/'},
                    {name: '推荐民宿', ptah: '/tokyoHouse'},
                    {name: '接机送机', ptah: '/shuttlePlane'},
                    {name: '折扣券', ptah: '/coupon'},
                    {name: '故事', ptah: '/storyList'},
                    {name: '收藏', ptah: '/center/collection'},
                    {name: '帮助', ptah: '/center/question'},
                ],
                dropdownList: [
                    {name: '个人中心',icon:'el-icon-user', command: '/center'},
                    {name: '最新通知',icon:'el-icon-bell', command: '/center/msgCenter'},
                    {name: '我的订单',icon:'el-icon-document', command: '/center/myOrder'},
                    {name: '退出登录',icon:'el-icon-back', command: 'loginOut'},
                ],
                identifiers: []
            }
        },
        created() {
            this.getIdentifiers();
            this.$eventBus.$on('login', this.handlerOnlogin)
        },
        computed: {
            ...mapState(['userInfo'])
        },
        beforeDestroy(){
            this.$eventBus.$off('login', this.handlerOnlogin)
        },
        methods: {
            async getIdentifiers() {
                let [e, data] = await this.$api.getIdentifiersApi();
                this.identifiers = data.result;
            },
            handleCommand(ptah){
                if(ptah === 'loginOut'){
                    this.loginOut()
                }else {
                    this.$router.push({path: ptah})
                }
            },
            @delToast('是否退出登录？')
            loginOut(){
                if(this.$route.path.indexOf('/center')>=0){
                    this.$router.replace('/')
                }
                this.$store.commit('removeUserInfo')
            },
            handlerOnlogin(){
                this.$store.commit('removeUserInfo');
                this.showLogin = true;
            }
        }
    }
</script>

<style scoped lang="less">
    .head-content {
        width: 100%;
        height: 80px;
        background-color: #e44646;
        position: sticky;
        top: 0;
        left: 0;
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;

        .head-body {
            width: 1200px;
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .logo-img {
                margin-right: 30px;
            }

            .menu-item {
                height: 100%;
                padding: 0 10px;
                cursor: pointer;
                line-height: 80px;
                font-size: 14px;
                color: #fff;
                text-decoration: none;
            }
            .menu-item-active{
                font-weight: bold;
                font-size: 16px;
            }

            .menu-line {
                width: 1px;
                height: 14px;
                background-color: #ffffff;
            }

            .login-content {
                margin-left: auto;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #ffffff;
            }
        }
    }
</style>
